import { AlmeAppUtilsBase } from "../AlmeApp/AlmeAppState";
import { TerminateLiveChat } from "../LiveChat/AlmeLiveChatReportingEvents";
import * as Loaders from '@alme/storage-ts/CookieLoader';
import { CookieAlmeSessionDataLoader } from '@alme/session-ts/CookieAlmeSessionDataLoader';
import { gettopdomain } from '../../utils/UrlUtils';
const storageLoader = new Loaders.CookieLoader('almeSession');
storageLoader.cookieOptions = { domain: gettopdomain() };
const cookieSessionLoader = new CookieAlmeSessionDataLoader(storageLoader);
const sessionDataLoader = cookieSessionLoader;
export class SessiontTimeoutUtils extends AlmeAppUtilsBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils) {
        super(almeState, setAlmeState, appConfig);
        this.apiUtils = apiUtils;
        this.almeSession = sessionDataLoader.GetAlmeSessionData();
    }
    async onSessionTimeout() {
        await TerminateLiveChat(this.apiUtils, this.almeState);
        this.apiUtils.createNewSessionData();
        const expiredResponse = this.getExpiredResponse();
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { sessionExpired: true, isLoggedIn: false, lastActivityTime: undefined, lastEntryId: this.appConfig.history.expiredResponse.entryId, history: [expiredResponse], isLiveChatConnected: false }));
    }
    async onUserSessionRefresh() {
        if (this.almeState.isLiveChatConnected) {
            this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { lastActivityTime: Date.now() }));
        }
        else {
            const variableName = "UserRefreshedSessionTimeout";
            await this.apiUtils.sendReportingEvent(variableName, variableName);
        }
    }
    getExpiredResponse() {
        var _a;
        const responseRevision = 1;
        return {
            id: this.appConfig.history.expiredResponse.entryId,
            userId: ((_a = this.almeSession) === null || _a === void 0 ? void 0 : _a.userId) || "",
            text: this.appConfig.expiredErrorResponse,
            responseRevision: responseRevision,
            displayLinkCollection: {
                Sections: [],
                Metadata: null,
            },
            navUrl: null,
            responseActions: [],
            deferredAppCall: null,
            maskedInput: null,
            isReverted: false,
            extensionData: {
                entryId: this.appConfig.history.expiredResponse.entryId,
                chatId: "",
                MessageIndex: -1,
            },
        };
    }
}
